import TpPlatformInvoiceSummaryItem from './TpPlatformInvoiceSummaryItem';

// "Assignment" sub-tab of the Summarized Invoice Items tab: the reconciliation pair —
// Bravo's stamped shop counts/amounts against the platform-reported ones.
export default class TpPlatformInvoiceSummaryAssignmentItem extends TpPlatformInvoiceSummaryItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Office',
        orderById: 'OfficeName',
        data: 'OfficeName',
        className: 'text-left',
        minWidth: 60,
      },
      {
        label: 'Caspian Client',
        orderById: 'ClientName',
        data: 'ClientName',
        className: 'text-left',
        minWidth: 80,
      },
      {
        label: 'Bravo Shop Count',
        orderById: '',
        data: (item) => TpPlatformInvoiceSummaryItem.getBravoShopCountCellContent(item),
        className: 'text-center',
        minWidth: 40,
      },
      {
        label: 'Platform Shop Count',
        orderById: '',
        data: 'ThirdPartyShopCountApi',
        className: 'text-center',
        minWidth: 40,
      },
      {
        label: 'Amount',
        orderById: '',
        data: 'TotalAmount',
        className: 'text-right',
        minWidth: 40,
      },
      {
        label: 'Platform Amount',
        orderById: '',
        data: 'ThirdPartyAmountApi',
        className: 'text-right',
        minWidth: 40,
      },
    ];
  }
}
